import { CellContext } from '@tanstack/react-table'
import { observer } from 'mobx-react-lite'
import * as React from 'react'
import { OrgPersonalSkillsTableRow } from '../data'
import profileSkillIcon from 'app/packs/images/icons/profile-skill.svg'

export const NameCell = observer(
  (data: CellContext<OrgPersonalSkillsTableRow, unknown>) => {
    const row = data.row.original

    return (
      <div className="flex gap-x-3 items-center">
        <div
          className="flex-shrink-0 h-8 w-8 rounded"
          style={{
            background: `url("${profileSkillIcon}") center/cover no-repeat`,
          }}
        />
        <span className="font-semibold text-gray-900 text-sm">{row.name}</span>
      </div>
    )
  }
)
